// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25izU","productName":"Table_productName__2_LMM"};